import Plyr from 'plyr';
const plyr = {
	ui: {},

	init: function() {
		let $plyr = document.querySelectorAll('.js-plyr');
		for (let i = 0; i < $plyr.length; i++) {
			let plyr_id = '#'+$plyr[i].getAttribute('id');
			$plyr[i].classList.add('show');
			let autoplay = $plyr[i].hasAttribute('autoplay');
			let sourcesDesktop = [
				{
					'src':$plyr[i].getAttribute('data-vimeoId'),
      				'provider': 'vimeo',
				},
			];
			let sourcesMobile = undefined;
			if($plyr[i].getAttribute('data-vimeoIdMobile')){
				 sourcesMobile = [{
					'src':$plyr[i].getAttribute('data-vimeoIdMobile'),
	  				'provider': 'vimeo',
				}];
			}

		    // Setup the player
		    let plyr_player = new Plyr(plyr_id, {
				// debug: true,
				controls: ['play', 'progress', 'current-time', 'mute', 'fullscreen'],
				settings: [],
				autoplay: autoplay,
				muted: autoplay,
				preload: autoplay,
				storage:    { enabled: false, key: 'plyr' },
				clickToPlay: true,
				// loadSprite: true,
				iconPrefix: 'icon-plyr',
				iconUrl: '/dist/icomoon/symbol-defs.svg',
				loop: { active: autoplay },
				// previewThumbnails: {
				//   enabled: true,
				//   src: ['https://cdn.plyr.io/static/demo/thumbs/100p.vtt', 'https://cdn.plyr.io/static/demo/thumbs/240p.vtt'],
				// },
				// type:'embed',
				type:'video',
				vimeo: {
					// Prevent Vimeo blocking plyr.io demo site
					referrerPolicy: 'no-referrer',
					byline: false,
					portrait: false,
					title: false,
					speed: true,
					transparent: false,
					loop: true,
					muted: true,
				},
				// mediaMetadata: {
				//   title: 'View From A Blue Moon',
				//   album: 'Sports',
				//   artist: 'Brainfarm',
				//   artwork: [
				//     {
				//       src: 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg',
				//       type: 'image/jpeg',
				//     },
				//   ],
				// },
			});

		    let lastSourceType = null;
			let sourceBySize = function(){
				let sources = sourcesDesktop;
				let sourceType = 'desktop';
				if(window.matchMedia("(max-width: 768px)").matches && sourcesMobile != undefined){
					sources = sourcesMobile;
					sourceType = 'mobile';
				}
				if(lastSourceType != sourceType){ // si pas de changement de taille, on change pas la source actuelle
					plyr_player.source = {
						type: 'video',
						title:'video title',
						sources: sources
					};
					lastSourceType = sourceType;
				}
			};
			sourceBySize();

			window.addEventListener('resize', ()=>{
				sourceBySize();
			});
		}

		// let $plyr_mobile = document.querySelectorAll('.js-plyr-mobile');
		// for (let i = 0; i < $plyr_mobile.length; i++) {
		// 	$plyr_mobile[i].classList.add('show')
		// }
		// if(window.matchMedia("(min-width: 769px)").matches){
		// 	let plyr_player = Plyr.setup('.js-plyr', {
		// 		controls: ['play', 'progress', 'current-time', 'mute', 'fullscreen'],
		// 		settings: [],
		// 		autoplay: true,
		// 		muted: true,
		// 		loop: true,
		// 		vimeo: {
		// 			// byline: false,
		// 			// portrait: false,
		// 			// title: false,
		// 			// speed: true,
		// 			// transparent: false,
		// 			loop: true,
		// 		},
		// 		preload: true,
		// 		storage:    { enabled: false, key: 'plyr' },
		// 		clickToPlay: true,
		// 	});
		// 	for (let i = 0; i < $plyr.length; i++) {
		// 		$plyr[i].classList.remove('hide')
		// 	}

		// 	for (let i = 0; i < $plyr_mobile.length; i++) {
		// 		$plyr_mobile[i].classList.add('hide')
		// 	}
		// }else{
		// 	let plyrMobile_player = Plyr.setup('.js-plyr-mobile', {
		// 		controls: ['play', 'progress', 'current-time', 'mute', 'fullscreen'],
		// 		settings: [],
		// 		autoplay: true,
		// 		muted: true,
		// 		loop: true,
		// 		vimeo: {
		// 			// byline: false,
		// 			// portrait: false,
		// 			// title: false,
		// 			// speed: true,
		// 			// transparent: false,
		// 			loop: true,
		// 		},
		// 		preload: true,
		// 		storage:    { enabled: false, key: 'plyr' },
		// 		clickToPlay: true,
		// 	});
		// 	for (let i = 0; i < $plyr.length; i++) {
		// 		$plyr[i].classList.remove('show')
		// 	}

		// 	for (let i = 0; i < $plyr_mobile.length; i++) {
		// 		$plyr_mobile[i].classList.add('hide')
		// 	}
		// }
	}

};

module.exports = plyr;